const options = {
  5: "bg-gray-700/5",
  10: "bg-gray-700/10",
  25: "bg-gray-700/25",
  50: "bg-gray-700/50",
  75: "bg-gray-700/75",
  90: "bg-gray-700/90",
  100: "bg-gray-700",
};

const from = {
  5: "from-gray-700/5",
  10: "from-gray-700/10",
  25: "from-gray-700/25",
  50: "from-gray-700/50",
  75: "from-gray-700/75",
  90: "from-gray-700/90",
  100: "from-gray-700",
};

export default function getBackgroundGray700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
